import { Effect } from "../Materials/effect";
var name = 'gpuUpdateParticlesPixelShader';
var shader = "#version 300 es\nvoid main() {\ndiscard;\n}\n";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var gpuUpdateParticlesPixelShader = { name: name, shader: shader };
//# sourceMappingURL=gpuUpdateParticles.fragment.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babylonjs/core/Shaders/gpuUpdateParticles.fragment.js
// module id = null
// module chunks = 